import * as React from 'react';
import { G, Path } from 'react-native-svg';

function Teeth() {
  return (
    <G stroke="#000" strokeLinecap="round">
      <Path
        d="M76.64 121.77a6.68 6.68 0 01-.11 5l-7.71.29a2.29 2.29 0 01-1.92-.52 2.23 2.23 0 01-.35-1.53v-4.39a47.64 47.64 0 014.9-.53l.09 2c.06 1.54.13 3.07.31 4.6a51.89 51.89 0 01-.67-5.41c0-.2 0-.44.15-.56a.67.67 0 01.37-.07c1.6-.02 3.4.92 4.94 1.12z"
        fill="#fff"
        strokeMiterlimit={10}
      />
      <Path
        d="M44 105.36a7.6 7.6 0 001.76 7.74c3.08 3 7.88 2.5 12 3.51a7.72 7.72 0 013.34 1.59 4.11 4.11 0 011.44 3.38 5.54 5.54 0 014.4-2.08 23.91 23.91 0 015 .64 32.84 32.84 0 006.71.45 10 10 0 005.49-1.44A4.68 4.68 0 0086 114"
        fill="none"
        strokeLinejoin="round"
        strokeWidth={1.71}
      />
    </G>
  );
}

export default Teeth;
